import { useState, useMemo } from 'react';

import '../../styles/buttons.css';

import PeopleTable from '../../components/people/peopleTable';
import PageHeader from '../../components/general/pageHeader';
import SignUpForm from '../../components/forms/createUserForm';
import Loading from '../../components/general/loading.js';
import useAuthenticate from '../../components/authentication/authenticate.js';

const ManagementPage = () => {
  const managementRoles = useMemo(() => ['manager', 'staff'], []);
  const [showFilters, setShowFilters] = useState(false);

  const { isLoading } = useAuthenticate();

  return (
    <div className="w-full">
    {isLoading ? (
      <Loading />
      ) : (
        <>
      <PageHeader pageName="Staff and Management" />
          <div className="page-header" style={{ justifyContent: 'flex-end' }}>
            <button className='filter-button' onClick={() => setShowFilters(prev => !prev)}>
              <i className="fas fa-filter"></i>Filter
            </button>
            <SignUpForm onNewManagerProperty={() => { }} />
          </div>
          <PeopleTable rolesToShow={managementRoles} showFilters={showFilters} showRoleFilter={true} />
        </>
      )}
    </div>
  );
};

export default ManagementPage;
